// extracted by mini-css-extract-plugin
export default {"searchBox":"searchBox_searchBox__9s97Y","input":"searchBox_input__AHWas","button":"searchBox_button__1ruHf"};